import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { CustomersService } from '../customers/customers.service';
import { CartService } from '../cart/cart.service';
import { ResidentsService } from '../residents';
import { AuthenticationService } from '../authentication';
import { PermissionsService } from '../permissions/permissions.service';
import { DetailedCustomer } from '../../../shared/models/customer.model';
import { UserRole } from '../../types/enums';
import { CUSTOMER_DATA_CONFIRMED } from '../../types/constants';
import { ConfirmCustomerDataModalComponent } from '../../../shared/components/confirm-customer-data-modal/confirm-customer-data-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ActiveCustomerService {
  constructor(
    private customersService: CustomersService,
    private cartService: CartService,
    private residentsService: ResidentsService,
    private authenticationService: AuthenticationService,
    private permissionsService: PermissionsService,
    private dialog: MatDialog
  ) {}

  async activate(customerId: number): Promise<DetailedCustomer | null> {
    try {
      const [, customer] = await Promise.all([
        firstValueFrom(this.cartService.fetchCustomerCarts()),
        firstValueFrom(this.customersService.getCustomer(customerId)),
        this.loadResidentOrdersSum(customerId),
      ]);
      this.confirmCustomerDataIfNeeded();
      return customer.data;
    } catch {
      return null;
    }
  }

  private async loadResidentOrdersSum(customerId: number): Promise<void> {
    try {
      await firstValueFrom(
        this.residentsService.getResidentOrdersSum(customerId.toString())
      );
    } catch {
      // The shop opens without up-to-date resident budgets.
    }
  }

  private confirmCustomerDataIfNeeded(): void {
    const shouldConfirm =
      !this.authenticationService.getLastLogin() &&
      this.permissionsService.hasRole([UserRole.Admin]) &&
      this.authenticationService.getCustomerIdFromToken() &&
      localStorage.getItem(CUSTOMER_DATA_CONFIRMED) !== 'true';
    if (!shouldConfirm) return;

    this.dialog.open(ConfirmCustomerDataModalComponent, {
      autoFocus: false,
      width: '90vw',
      maxWidth: '1500px',
      height: 'auto',
      maxHeight: '100vh',
      disableClose: true,
    });
  }
}
